export const UNIT_DELETE_UNIT_BEGIN = 'UNIT_DELETE_UNIT_BEGIN';
export const UNIT_DELETE_UNIT_SUCCESS = 'UNIT_DELETE_UNIT_SUCCESS';
export const UNIT_DELETE_UNIT_FAILURE = 'UNIT_DELETE_UNIT_FAILURE';
export const UNIT_DELETE_UNIT_DISMISS_ERROR = 'UNIT_DELETE_UNIT_DISMISS_ERROR';
export const UNIT_SAVE_UNIT_BEGIN = 'UNIT_SAVE_UNIT_BEGIN';
export const UNIT_SAVE_UNIT_SUCCESS = 'UNIT_SAVE_UNIT_SUCCESS';
export const UNIT_SAVE_UNIT_FAILURE = 'UNIT_SAVE_UNIT_FAILURE';
export const UNIT_SAVE_UNIT_DISMISS_ERROR = 'UNIT_SAVE_UNIT_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/unit/redux/constants.js